import { render } from "./MenuMixins.vue?vue&type=template&id=7d1c96b3"
import script from "./MenuMixins.vue?vue&type=script&lang=js"
export * from "./MenuMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__